import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    hint: 'Not required',
    placeholder: 'Your answer',
    subtitle: 'Explain in a few words why you want to close your account.',
    title: 'Other',
  },
  fr: {
    hint: 'Facultatif',
    placeholder: 'Votre réponse',
    subtitle:
      'Expliquez en quelques mots pourquoi vous souhaitez clôturer votre compte.',
    title: 'Autre',
  },
});
